import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spin } from 'antd';
import { useSelector } from 'react-redux';
import { AUTH_PREFIX_PATH, UNAUTHENTICATED_ENTRY, REDIRECT_URL_KEY, AUTHENTICATED_ENTRY } from 'configs/AppConfig';
import ErrorOne from 'views/auth-views/errors/error-page-1';

const getAllowedPaths = (menuList) => {
	console.log("menuList product route", menuList);
	const paths = [];

	const traverse = (items) => {
		items.forEach(item => {
			if (item.path) {
				paths.push(`/app${item.path}`);
			}
			if (item.submenu) {
				traverse(item.submenu);
			}
		});
	};
	traverse(menuList);
	return paths;
};

const ProtectedRoute = () => {
	const { token, user_name, userMenu } = useSelector(state => state.auth);
	const location = useLocation();
	const pathname = location.pathname;

	if (token && (!userMenu || userMenu.length === 0)) {
		return (
			<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
				<Spin size="small" />
			</div>
		);
	};

	if (!token) {
		return <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}?${REDIRECT_URL_KEY}=${pathname}`} replace />;
	}

	if (pathname === '/' || pathname === '/app' || pathname === '/app/') {
		return <Navigate to={AUTHENTICATED_ENTRY} replace />;
	}

	const allowedPaths = getAllowedPaths(userMenu);

	const WHITELIST_PATHS = [
		'/app/pages/profile',
	];

	const matchPath = (pathList, currentPath) => {
		return pathList.some((path) => currentPath.startsWith(path));
	};

	const hasAccess = matchPath(allowedPaths, pathname) || matchPath(WHITELIST_PATHS, pathname);

	if (!hasAccess) {
		return <ErrorOne />;
	}

	return <Outlet />;
};

export default ProtectedRoute;
